module.exports = __webpack_public_path__ + "img/bottom-sheet.9f58970a.webp";